__turbopack_context__.v({
  "gdprDisclaimer": "TermsAndConditions-module__rwxNuG__gdprDisclaimer",
  "infoIcon": "TermsAndConditions-module__rwxNuG__infoIcon",
  "js-has-pseudo": "TermsAndConditions-module__rwxNuG__js-has-pseudo",
  "modalBody": "TermsAndConditions-module__rwxNuG__modalBody",
  "modalContainer": "TermsAndConditions-module__rwxNuG__modalContainer",
  "modalHeader": "TermsAndConditions-module__rwxNuG__modalHeader",
  "privacy": "TermsAndConditions-module__rwxNuG__privacy",
  "termsAndConditions": "TermsAndConditions-module__rwxNuG__termsAndConditions",
});
